import { api, type Paginated } from "./client";

// Mirrors app/routers/activity.py LoginEventOut.
export interface LoginEvent {
  login_event_id: number;
  user_id: number | null;
  username: string | null;
  remote_ip: string | null;
  created_at: string | null;
}

export interface LoginListParams {
  page?: number;
  per_page?: number;
  username?: string;
}

export async function listLogins(params: LoginListParams): Promise<Paginated<LoginEvent>> {
  const resp = await api.get<Paginated<LoginEvent>>("/activity/logins", { params });
  if (!resp.data.success) throw new Error(resp.data.error || "Failed to load activity");
  return resp.data;
}
